import BaseComponent from "@js/components/base_component.jsx";

import { Fragment } from "react";
import { Provider, connect } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";

import rootReducer from "@js/reducers/mui/role_selection.js";

import {
  showRoleSelectionModal,
  hideRoleSelectionModal,
} from "@js/actions/mui/role_selection.js";

class MuiRoleSelection extends BaseComponent {

  constructor(props) {
    super(props);

    this.store = createStore(
      rootReducer,
      {
        activeRoleName: props.active_role.name,
        availableRoles:  props.available_roles,
      },
      composeWithDevTools(applyMiddleware(thunk)),
    );
  }

  render() {
    return (
      <Provider store={ this.store }>
        <MuiRoleSelectionComponent />
      </Provider>
    );

  }

}

class MuiRoleSelectionClass extends BaseComponent {

  componentDidMount() {
    document.addEventListener("click", this._onRootClick);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this._onRootClick);
  }

  render() {
    return (
      <Fragment>
        <a
          ref={ (n) => { this._rootNode = n; } }
          onClick={ (e) => { e.preventDefault() ; e.stopPropagation() ; this.props.dispatch(showRoleSelectionModal()) } }
        >
          {
            this.props.activeRoleName
              ? this.props.activeRoleName
              : I18n.t("monitor.account_selection_none_active")
          }
        </a>
        {
          this.props.showRoleSelectionModal &&
            <ul className="dropdown-menu dropdown-alerts show">
              {
                this.props.availableRoles.map((role, ii) => (
                  <li key={ ii }>
                    <a href={ Routes.mui_role_selection_path(role.id) }>
                      { role.name }
                    </a>
                  </li>
                ))
              }
            </ul>
        }
      </Fragment>
    );
  }

  _onRootClick(e) {
    const domNode = this._rootNode;

    if ( !domNode || !domNode.contains(e.target) ) {
      this.props.dispatch(hideRoleSelectionModal());
    }
  }

}

const MuiRoleSelectionComponent = connect((state) => ({
  activeRoleName: state.activeRoleName,
  availableRoles: state.availableRoles,
  showRoleSelectionModal: state.showRoleSelectionModal,
}))(MuiRoleSelectionClass);

export default MuiRoleSelection;
